import Ledger from 'components/global/Ledger';

export default Ledger;
